import rut from "./rut";

export const hasRole = (user, role) => {
    return user.roles.filter(userRole => userRole.name === role).length >= 1;
}

export const usersAreValid = (users, quantity = null, isResponsibleForAssistants = false) => {
    if (isResponsibleForAssistants) return true;

    if (!users) return false;
    if (!Array.isArray(users)) return false;
    if (users.length <= 0) return false;

    const userFieldsAreValid = users.every(user => {
        if (!user.name || !user.lastname) {
            return false;
        }

        if (!user.assumed_guest) {
            if (!user.rut || !rut.validate(user.rut)) {
                return false;
            }
        }

        return true;
    })

    if (!userFieldsAreValid) return false;
    if (quantity) {
        if (users.length !== parseInt(quantity)) return false;
    }

    return true;
}

export const userIsValid = (user) => {
    if (!user) return false;

    if (!user.name || !user.lastname) {
        return false;
    }

    if (!user.rut || !rut.validate(user.rut)) {
        return false;
    }

    return true;
}